import * as swcHelpers from '@swc/helpers';
import { isLineItemReorderable } from '../../utils/is-line-item-reorderable.js';
import '@grandvisionhq/utils';
import '../view/utils/get-payment-status-label.js';
import { isContactLensesOrderLineItem } from '../view/utils/order-line-item-product-type-guards.js';
import '@grandvisionhq/graphql';

const toEyeSide = (eyeSide)=>{
    switch(eyeSide){
        case 'LEFT':
            return 'left';
        case 'RIGHT':
            return 'right';
        case 'BOTH':
            return 'both';
        default:
            return undefined;
    }
};
const convertLineItemToDraft = (orderLineItem)=>{
    const draft = {
        quantity: orderLineItem.quantity,
        sku: orderLineItem.product.sku,
        type: 'regular'
    };
    if (isContactLensesOrderLineItem(orderLineItem)) {
        const _prescription = orderLineItem.prescription, contactLensPrescription = swcHelpers.objectWithoutProperties(_prescription, [
            "__typename"
        ]);
        return swcHelpers.objectSpread({}, draft, {
            type: 'contact-lenses',
            typeDetails: {
                eyeSide: toEyeSide(orderLineItem.eyeSide),
                contactLensPrescription
            }
        });
    }
    return draft;
};
const toDrafts = (orderLineItems)=>{
    if (!orderLineItems) {
        return {};
    }
    return Object.fromEntries(orderLineItems.filter(isLineItemReorderable).map((lineItem)=>[
            lineItem.id,
            convertLineItemToDraft(lineItem)
        ]
    ));
};

export { toDrafts };
//# sourceMappingURL=to-drafts.js.map
